export const HOTSPOT_TYPES = {
  NAVIGATION: "navigation",
  TEXT: "text",
};

export const HOTSPOT_TYPE_OPTIONS = [
  { value: HOTSPOT_TYPES.NAVIGATION, label: "Navigation" },
  { value: HOTSPOT_TYPES.TEXT, label: "Text" },
];

export const getHotspotType = hotspot => hotspot?.type || HOTSPOT_TYPES.NAVIGATION;

export const isTextHotspot = hotspot => getHotspotType(hotspot) === HOTSPOT_TYPES.TEXT;
